/**
 * Interceptor responsável por transformar datas recebidas pelo cliente em formato String
 * para o formato objeto JS Date.
 * 
 * O serviço de back-end deve garantir que os objetos JSON a serem tratados contenham um 
 * campo "modelClass" onde está definido o seu nome de classe.
 */

/*
 * Na implementação inicial deste interceptor, não havia a discriminação entre os tipo date e datetime.
 * Inicialmente, os campos do modelo de domínio lidavam apenas com dados do tipo data, sem a parte das horas.
 * Quando surgiu a necessidade de trabalhar com os primeiros campos do tipo hora, o interceptor precisou
 * ser evoluído. Isso porque, se tratamos os campos exclusivamente "data" também como "data e hora",
 * os ajustes de timezone acabam fazendo com que uma data passe para o outro dia inadivertidamente. 
 * 
 * Este problema poderia ser evitado garantindo apenas que, tanto o cliente quanto o servidor, incluindo o
 * armazenamento em banco de dados trabalhassem sempre com o mesmo timezone. Essa garantia porém, não é
 * simples de ser conseguida, em particular pois não é fácil administrar as configurações do browser e
 * sistema operacional do cliente, que podem levar a inconsistências. Sendo assim, se preferiu convencionar
 * que os dados de tempo do sistema são sempre transportados em UTC.
 * 
 * Vamos falar agora de um dado exclusivamente data, como a data de nascimento de um cliente. Esta data é
 * armazenada em UTC como, por exemplo: 1981-10-10 00:00. Ao instanciar um objeto Javascript do tipo Date,
 * existem duas opções: passar um argumento informando que trata-se de uma data UTC ou uma data local.
 * Se usamos data UTC, o aniversário do cliente será exibido como 09/10, pois as 3 horas de diferença do
 * fuso brasileiro antecipam a data. Uma alternativa seria armazenar a data como 1981-10-10 03:00. Porém
 * o problema se repetiria para outras localidades com fuso menor que -3.
 * 
 * Para contornar este problema, se decidiu incluir no interceptor a definição do tipo de dado (date ou
 * datetime). Assim, quando um dado do tipo date é informado, consideramos que está em horário local,
 * evitando qualquer conversão. Quando o dado é datetime, consideramos que está em UTC, e as conversões
 * apropriadas serão realizadas.
 */

angular.module("avlib").provider("dateInterceptor", function(){

	/**
	 * Relação de nomes de classes que serão processadas pelo interceptor
	 * com os respectivos campos de data.
	 */
	var acceptedModelClasses = [];

	var logEnabled = false;

	/**
	 * Constrói um objeto AcceptedClass que representa uma classe a ser
	 * tratada pelo interceptor e os respectivos atributos de data.
	 */
	var AcceptedClass = function(className, attributes){
		this.className = className;
		this.attributes = attributes;
	};

	this.registerClass = function(className, attributes){
		acceptedModelClasses.push(new AcceptedClass(className, attributes));
	};

	this.setLogEnabled = function(enabled){
		logEnabled = enabled;
	};

	this.$get = ["$log", function($log){

		/**
		 * Analisa a classe do objeto especificado para determinar se trata-se de um objeto
		 * a ser convertido. Em caso positivo, analisa cada um dos atributos. Se o atributo
		 * está na lista de conversões, realiza o processamento devido.
		 * 
		 * @param object o objeto a ser analisado e convertido
		 */
		var checkObjectType = function(object){
			acceptedModelClasses.forEach(function(acceptedClass){
				if (object.modelClass === acceptedClass.className){
					log("Date Interceptor detectou classe alvo: "+acceptedClass.className);
					//$log.debug("Atributos a serem transformados: "+acceptedClass.attributes);
					acceptedClass.attributes.forEach(function(attribute){
						log("Iniciando análise do tipo: "+attribute);
						var colonIndex = attribute.indexOf(':');
						var type = attribute.substr(colonIndex+1);
						convertObject(type, object, attribute.substr(0, colonIndex));
					}); // foreach attribute
				} // found accepted class
			}); // foreach accepted class
		};
		
		var convertObject = function(type, object, path){
			log("Analisando segmento: "+path);
			
			var dotIndex = path.indexOf('.');
			
			if (dotIndex == -1){
				convertSimpleAttribute(object, path, type, '');
			}else{
				var attribute = path.substr(0, dotIndex);
				
				if (".*" == path.substr(dotIndex, 2)){
					log("Detectado array");
					var nextDotIndex = path.indexOf('.', dotIndex+2);
					var subAttribute = path.substr(nextDotIndex+1);
					// Obtendo o array de fato:
					var attArray = object[attribute];
					// Para cada elemento do array, convertemos a propriedade B:
					if (attArray != null){
						if (attArray.length > 0){
							for (var i=0; i<attArray.length; i++){
								convertSimpleAttribute(attArray[i], subAttribute, type, attribute);
							}
						}else{
							log("Array vazio.");
						}
					}else{
						log("Atributo nulo. Ignorando conversão");
					}
				}else{
					var nextDotIndex = path.indexOf('.', dotIndex+1);
					if (nextDotIndex > -1){
						convertObject(type, object[attribute], path.substr(dotIndex+1));
					}
				}
			}
		};
		
		/**
		 * Verifica se o array informado possui o atributo especificado e, em caso,
		 * positivo, procede com a transformação do valor textual deste atributo
		 * em um objeto Date.
		 * 
		 * @param {array} array o array que será transformado
		 * @param {string} attribute o nome do atributo que será transformado
		 * @param {string} o tipo do campo que será transformado (date ou datetime)
		 */
		var convertSimpleAttribute = function(array, attribute, type, attPath){
			if (array[attribute] != null){
				log("Transformando atributo: "+attPath+"."+attribute);
				if (type == "date"){
					/*
					 * Quando a conversão é feita direto através do objeto Date, datas do tipo
					 * 2019-10-31 são interpretadas como UTC e transformadas para o timezone local.
					 * Isso acaba fazendo com que o dia do ano seja alterado, o que na maioria das vezes
					 * não é o comportamento esperado por uma aplicação que optou por utilizar o tipo date.
					 * Para evitar esse problema, fazemos o parsing utilizando a biblioteca moment. A
					 * biblioteca moment irá considerar a data no timezone local.
					 */
					//new Date(array[attribute]);
					var converted = moment(array[attribute]).toDate();
					log("[DATE] "+attribute+": "+array[attribute]+" -> "+converted);
					array[attribute] = converted;
				}else if (type == "datetime"){
					// Com dado do tipo datetime, incluimos o Z final sinalizando que trata-se de data UTC.
					log("[DATETIME] "+attribute+": "+array[attribute]+" -> "+new Date(array[attribute]+"Z"));
					array[attribute] = new Date(array[attribute]+"Z");
				}
			}else{
				log("Atributo nulo. Ignorando conversão");
			}
		};
		
		var log = function(msg) {
			if (logEnabled) $log.debug(msg);
		}
		
		return {
			response: function(response) {
				log("Date Interceptor iniciando execução");
				var contentType = response.headers()['content-type']
				if(contentType && contentType.indexOf("application/json") > -1){
					log("Objeto JSON identificado");
					if (Array.isArray(response.data)){
						response.data.forEach(function(element){
							checkObjectType(element);
						});
					}else{
						checkObjectType(response.data);
					}// if-else isArray
				} // if is JSON
				log("Date Interceptor finalizando execução");
				return response;
			}
		};
	}];
});
